import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { app } from "./config";

export function createClients() {
  if (typeof window === "undefined") {
    return { app: null, auth: null, db: null };
  }

  const auth = getAuth(app);
  const db = getFirestore(app);

  return { app, auth, db };
}
